<script setup lang="ts">
// Note Google sur une ligne de réassurance (« 4,8 ★ 323 avis Google »), même source que la fiche.
// Élément de liste : à placer dans le <ul> de réassurance du parent, qui en fixe la typographie.
import { computed } from "vue";
import { usePage } from "@inertiajs/vue3";
import StarFull from "@/Components/Icons/StarFull.vue";

withDefaults(
    defineProps<{
        /** Nombre d'étoiles affichées */
        stars?: number;
    }>(),
    { stars: 1 },
);

const page = usePage();

const rating = computed(() => page.props.googleRating?.rating ?? 0);
const total = computed(() => page.props.googleRating?.user_ratings_total ?? 0);
const label = computed(() =>
    rating.value.toLocaleString("fr-FR", { maximumFractionDigits: 1 }),
);
</script>

<template>
    <li v-if="rating > 0" class="google-rating">
        <b>{{ label }}</b>
        <span class="google-rating__stars" aria-hidden="true">
            <StarFull v-for="n in stars" :key="n" width="12" height="12" />
        </span>
        {{ total }} avis Google
    </li>
</template>

<style lang="scss" scoped>
.google-rating__stars {
    display: inline-flex;
    gap: 1px;
    color: $dark-font;
}
</style>
